import {translation} from "@2d-front-monorepo/core";
import {JSX} from "react";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {useCreditCard} from "../hooks/useCreditCardAssignment";
import {usePermits} from "../hooks/usePermits";
import {Link} from "react-router";
import {PrivateRoutes} from "../routes";
import MaterialIcon from "./MaterialIcon";

export default function AddCreditCardMessage(): JSX.Element | undefined {
	const {permits} = usePermits();
	const creditCard = useCreditCard();

	return creditCard == null && permits.length > 0
		? <div className="form-message form-message--warning">
			<p className="layout horizontal aligned middle credit-card-warning">
				<MaterialIcon icon="warning"/>
				<span className="credit-card-warning--text">{translation(PermitTranslations.payments_page__no_card)}</span>
				<span className="flex"></span>
				<Link to={PrivateRoutes.payments}
				      className="form__button form__button--primary form__button--small">{translation(PermitTranslations.payments_page__add_new_card)}</Link>
			</p>
		</div>
		: undefined;
};
